/* eslint-disable */ !(function (t) {
  t.Redactor.prototype.fontsize = function () {
    return {
      init: function () {
        var n = [10, 11, 12, 14, 16, 18, 20, 24, 28, 30],
          e = this,
          o = {};
        t.each(n, function (t, n) {
          o['s' + t] = {
            title: n + 'px',
            func: function () {
              e.fontsize.set(n);
            }
          };
        }),
          (o.remove = { title: 'Remove font size', func: e.fontsize.reset });
        var i = this.button.add('fontsize', this.lang.get('fontsize'));
        this.button.addDropdown(i, o);
      },
      set: function (t) {
        this.inline.format('span', 'style', 'font-size: ' + t + 'px;');
      },
      reset: function () {
        this.inline.removeStyleRule('font-size');
      }
    };
  };
})(jQuery);
